import React, { PureComponent } from 'react'
import { Modal } from 'react-bootstrap'
import EditGovDonorForm from './EditGovDonorForm';

interface AddGovDonorProps {
  show: boolean
  onHide: () => void
  onSuccess: () => void
}

export default class AddGovDonorModal extends React.Component<AddGovDonorProps> {

  render() {
    const { show, onHide } = this.props

    return <Modal backdrop="static" centered show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Add Donor</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EditGovDonorForm onSuccess={() => this.props.onSuccess()} onHide={this.props.onHide} editing PersonID={undefined} />
      </Modal.Body>
    </Modal>
  }
}

